import { ViewsField } from '@src/features/RiskAnalysis/components/fields/Views';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { isUndefined } from 'lodash';
import React from 'react';

/**
 * widget: Views
 *
 * The Views widget for the Risk Analysis screen.
 *
 * @param assets
 * @param children
 * @param form
 * @param setIsSelectingViews
 * @returns {Element}
 * @constructor
 */
export function Views({ assets = {}, children, form = {}, setIsSelectingViews = () => {} }) {
  return (
    <ErrorHandler location="src/features/RiskAnalysis/components/widgets/Views/Views.jsx">
      <Widget backgroundColor="var(--abyss-colors-gray1)" icon="visibility" title="Views">
        <Grid>
          <Grid.Col
            css={{ border: 'none !important' }}
            id="viewsContainer"
            span={{ md: '50%', sm: '100%', xs: '100%' }}
          >
            <Flex alignItems="end" justify="space-evenly">
              <div>
                <ViewsField assets={assets} form={form} setIsSelectingViews={setIsSelectingViews} />
              </div>
              {!isUndefined(children) && <div>{children}</div>}
            </Flex>
          </Grid.Col>
        </Grid>
      </Widget>
    </ErrorHandler>
  );
}
